import config from '@/config'
import { Model } from 'coloquent'
import { AxiosHttpClient } from 'coloquent/dist/httpclient/axios/AxiosHttpClient'
import axios from 'axios'

export abstract class AbstractNode extends Model {
  constructor () {
    super()

    // @ts-ignore
    const client = new AxiosHttpClient(axios.create(config.orrm.jsonapi))
    if (config.orrm.jsonapi.auth) {
      client.setWithCredentials(true)
    }
    AbstractNode.setHttpClient(client)
  }

  public getJsonApiBaseUrl (): string {
    return AbstractNode.getHttpClient().getImplementingClient().baseUrl
  }

  get uuid (): string | undefined {
    return this.getApiId()
  }

  get langcode (): string {
    return this.getAttribute('langcode')
  }

  get weight (): number {
    return this.getAttribute('weight')
  }
}
